import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/components/vlyt/ThemeProvider";

export default function ThemeToggle({ compact = false }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      data-testid="theme-toggle-btn"
      className={`inline-flex items-center justify-center rounded-full border border-[color:var(--vlyt-border)] hover:border-[color:var(--vlyt-lime)] text-[color:var(--vlyt-text)] hover:text-[color:var(--vlyt-lime)] ${
        compact ? "h-9 w-9" : "h-10 w-10"
      }`}
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
    >
      {isLight ? <Moon size={16} /> : <Sun size={16} />}
    </button>
  );
}
